import * as React                           from "react"
import {combineReducers}                    from "redux"
import {IsMenuToggle}                       from "./IsMenuToggle"
import {ActiveButton}                       from "./ActiveButton"

export const Menu = combineReducers({
  isMenuToggle : IsMenuToggle,
  activeButton : ActiveButton,
});
